import React from 'react';
import { Form, Input, TimePicker, Col, Row, Switch } from 'antd';
import moment from 'moment';

const { Item: FormItem } = Form;

/* eslint no-useless-escape: 0 */

/*-----------------------------------*/
/*             Component             */
/*-----------------------------------*/
const Component = ({ url = 'https://www.youtube.com/watch?v=1blxp_3zlaw', autoplay = 0, start = 0 }) => {
    const getMovieId = url => {
        let regex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
        let matches = url.match(regex);

        return matches ? matches[1] : null;
    };

    const createMovieUrl = () => {
        let src = 'https://www.youtube-nocookie.com/embed/' + getMovieId(url);
        src += '?iv_load_policy=3&modestbranding=1';
        src += '&autoplay=' + autoplay;
        src += '&start=' + start;

        return src;
    };

    return (
        <iframe
            title="YouTube media"
            src={createMovieUrl()}
            className="youtube-block"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        />
    );
};
/*-----------------------------------*/
/*               Form                */
/*-----------------------------------*/
const EditForm = props => {
    const { url, autoplay, start } = props;
    const { getFieldDecorator } = props.form;

    props.form.mapValuesToProps = values => {
        values.start = values.start ? values.start.hours() * 3600 + values.start.minutes() * 60 + values.start.seconds() : 0;
        values.autoplay = values.autoplay ? 1 : 0;
        return values;
    };

    /*-----------Validation methods-------------*/
    const validateUrl = (rule, value, callback) => {
        let regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
        if (value && value.match(regex)) {
            callback();
            return;
        } else {
            callback('Not a valid YouTube url.');
        }
    };

    return (
        <div>
            <Row type="flex" justify="start">
                <Col span={24}>
                    <FormItem label="Youtube video url" required hasFeedback>
                        {getFieldDecorator('url', {
                            rules: [
                                {
                                    validator: validateUrl
                                }
                            ],
                            initialValue: url
                        })(<Input name="url" placeholder="Video url" />)}
                    </FormItem>
                </Col>
            </Row>

            <Row type="flex" justify="start">
                <Col span={4}>
                    <Form.Item label="Autoplay">
                        {getFieldDecorator('autoplay', {
                            valuePropName: 'checked',
                            initialValue: autoplay === 1 ? true : false
                        })(<Switch name="autoplay" checkedChildren="Yes" unCheckedChildren="No" />)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Start at">
                        {getFieldDecorator('start', {
                            initialValue: start ? moment.utc(start * 1000) : moment('00:00:00', 'HH:mm:ss')
                        })(<TimePicker name="start" format="HH:mm:ss" />)}
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
};

export { Component, EditForm };
